/* eslint-disable */

import jack from 'jack-logs';

(function loadIntercom() {
  if (window.NATIVE_INTERCOM) { return null; }
  if (process.env.NODE_ENV === 'test') { return null; }
  const w = window;
  let ic = w.Intercom;
  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', intercomSettings);
  } else {
    const d = document;
    const i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
    function l() {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `https://widget.intercom.io/widget/${process.env.INTERCOM_ID}`;
      const x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }

    if (w.attachEvent) {
      w.attachEvent('onload', l);
      w.attachEvent('deviceready', l);
    } else {
      w.addEventListener('load', l, false);
      w.addEventListener('deviceready', l, false);
    }
    if (window.cordova) {
      l(); // by the time this loads inside cordova, it's ready.
    }
  }
})();

export default window.Intercom;

export async function getHash(userId) {
  const res = await fetch(`${process.env.TIMECLOCK_SERVER}/intercomhash`, {
    method: 'POST',
    body: JSON.stringify({ email: userId.toString() }),
    headers: {
      'Content-Type': 'application/json',
    }
  });
  if (res.ok) {
    const json = await res.json();
    return json.hash;
  }
}

export async function sendSignup({ userId, name, email, phone, created_at, company }) {
  try {
    const requestObject = {
      user_id: userId,
      name,
      email,
      phone,
      company: {
        ...company,
        timeclock_signup: true,
      },
      created_at,
      app_id: process.env.INTERCOM_ID,
      user_hash: await getHash(userId),
      org_admin: true,
      is_billing_contact: true,
      timeclock_signup: true,
    };
    if (window.cordova) {
      requestObject.on_device = true;
    } else {
      requestObject.in_browser = true;
    }
    if (process.env.BRANCH_SLUG === 'master' && process.env.NODE_ENV === 'production') {
      if (window.NATIVE_INTERCOM) {
        window.intercom.registerIdentifiedUser({ userId, email });
        window.intercom.updateUser({
          name,
          email,
          phone,
          companies: [{
            ...company,
            timeclock_signup: true,
          }],
          created_at,
          customer_attributes: {
            timeclock_signup: true,
            org_admin: true,
            is_billing_contact: true,
          }
        })
      } else {
        window.Intercom('boot', requestObject);
      }
    } else {
      console.log('Intercom#boot', requestObject);
    }
  } catch (e) {
    // we have an error?
    jack.error('Intercom Error', e.constructor.name, e.message);
  }

}



// WEBPACK FOOTER //
// ./src/lib/Intercom.js